import { useQuery } from "@tanstack/react-query";

import { adminInvoicesList, getAdminInvoicesPdfUrl } from "@motolynk/api-client";
import { useFeature, type VendorOrderDocumentsProps } from "@motolynk/app-core";
import { useTranslation } from "@motolynk/i18n";

import { INVOICED_STATUSES, InvoiceLinks } from "../shared/InvoiceLinks";

/** Admin order page, one vendor order: its GST invoice / credit notes (slot `orders.vendor_order.documents`). */
export function AdminInvoices({ vendorOrderNumber, status }: VendorOrderDocumentsProps) {
  const { t } = useTranslation("invoices");
  const enabled = useFeature("orders.gst_invoices") && INVOICED_STATUSES.includes(status);
  const query = { vendor_order: vendorOrderNumber, page_size: 50 };
  const rows = useQuery({
    queryKey: ["admin", "invoices", query],
    queryFn: async () => (await adminInvoicesList(query)).data,
    enabled,
  });
  if (!enabled) return null;
  return (
    <div className="space-y-2 border-t pt-3">
      <p className="text-sm font-semibold">{t("title")}</p>
      <InvoiceLinks
        rows={rows.data?.results}
        loading={rows.isPending}
        failed={rows.isError}
        pdfUrl={getAdminInvoicesPdfUrl}
      />
    </div>
  );
}
